import {
  getSessionStorageItem,
  setSessionStorageItem,
} from "../../utils/clientStorageUtils";

export interface ITravellerDetailsForm {
  primaryContactDetails?: {
    email: string;
    mobile: string;
  };
  travellerDetails?: {
    name: string;
    dob: string;
    gender: string;
    isSelected: boolean;
    isEdited: boolean;
    isSavedTraveller: boolean;
    passport: string;
    nomineeName?: string;
    travellerId?: number | string;
    infoSource?: string;
    selectionOrder?: number;
  }[];
  countryCode?: string;
  gstInfoDetails?: {
    gstNumber: string;
    companyDetails: string;
  };
}

const STORAGE_KEY = "insurance_traveller_details";

export const setTravDetailsInMemory = (value: any) => {
  if (typeof window !== "undefined") {
    try {
      setSessionStorageItem(STORAGE_KEY, value, true); // true = essential storage
    } catch (error) {
      console.error(
        "Failed to save traveller details to session storage:",
        error
      );
    }
  }
};

export const getTravDetailsFromMemory = (): ITravellerDetailsForm => {
  if (typeof window !== "undefined") {
    try {
      return getSessionStorageItem(STORAGE_KEY, true) || {};
    } catch (error) {
      console.error(
        "Failed to retrieve traveller details from session storage:",
        error
      );
      return {};
    }
  }
  return {};
};
